/* AutoShineX — product-card cart actions: Add to cart morphs to a quantity stepper; custom Buy now. */
(function () {
  'use strict';

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      // IMPORTANT: fetch does NOT reject on 4xx. A 422 (sold out / unpurchasable) must be
      // treated as a failure so we never redirect to checkout with nothing added.
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) { data = data || {}; data.__status = r.status; return Promise.reject(data); }
        return data;
      });
    });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateBadges(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      /* empty (not "0") when the cart is empty, so the bubble's :empty/hidden logic hides it */
      el.textContent = count > 0 ? (count < 100 ? String(count) : '99+') : '';
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', count === 0); });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
    });
  }

  function variantId(card) {
    var inp = card.querySelector('[name="id"]');
    return inp ? inp.value : null;
  }

  function buildUI(card) {
    if (card.__asxReady) return true;
    var form = card.querySelector('.shopify-product-form') || card.querySelector('form[action*="/cart"]');
    var vid = variantId(card);
    if (!form || !vid) return false;
    card.__asxReady = true;
    card.dataset.asxVid = vid;
    card.classList.add('asx-hasactions');

    // Compact card CTA: rename the "Add to cart" text to just "Add"
    var atcBtn = form.querySelector('.add-to-cart-button');
    if (atcBtn) {
      for (var ci = 0; ci < atcBtn.childNodes.length; ci++) {
        var tn = atcBtn.childNodes[ci];
        if (tn.nodeType === 3 && tn.textContent.trim()) { tn.textContent = 'Add'; break; }
      }
    }

    var step = document.createElement('div');
    step.className = 'asx-step';
    step.setAttribute('hidden', '');
    step.innerHTML =
      '<button type="button" class="asx-step__b" data-asx-dec aria-label="Decrease quantity">−</button>' +
      '<span class="asx-step__n" data-asx-num>1</span>' +
      '<button type="button" class="asx-step__b" data-asx-inc aria-label="Increase quantity">+</button>';

    var buy = document.createElement('button');
    buy.type = 'button';
    buy.className = 'asx-buy button button-secondary';
    buy.textContent = 'Buy now';

    form.appendChild(step);
    form.appendChild(buy);
    card.__asx = { form: form, step: step, buy: buy, atc: card.querySelector('add-to-cart-component') };

    step.querySelector('[data-asx-inc]').addEventListener('click', function () { changeQty(card, +1); });
    step.querySelector('[data-asx-dec]').addEventListener('click', function () { changeQty(card, -1); });
    buy.addEventListener('click', function () {
      buy.disabled = true;
      var orig = buy.textContent;
      buy.textContent = 'Adding…';
      // Only go to checkout AFTER the item is confirmed added (postJSON rejects on 422/errors).
      postJSON('/cart/add.js', { id: card.dataset.asxVid, quantity: 1 })
        .then(function () {
          buy.textContent = 'Redirecting…';
          // Go STRAIGHT to Shopflo checkout (same path as the PDP Buy now). Native /checkout is the last resort.
          if (typeof window.handleFloBuyNowBtn === 'function') { try { window.handleFloBuyNowBtn(); return; } catch (e) {} }
          if (window.Shopflo && typeof window.Shopflo.openCheckout === 'function') { try { window.Shopflo.openCheckout(); return; } catch (e) {} }
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          buy.disabled = false;
          buy.textContent = (err && (err.description || err.message)) ? 'Unavailable' : 'Try again';
          setTimeout(function () { buy.textContent = orig; }, 2200);
        });
    });
    return true;
  }

  function renderState(card, qty) {
    var a = card.__asx;
    if (!a) return;
    if (qty > 0) {
      a.step.removeAttribute('hidden');
      a.step.querySelector('[data-asx-num]').textContent = qty;
      if (a.atc) a.atc.classList.add('asx-hidden');
    } else {
      a.step.setAttribute('hidden', '');
      if (a.atc) a.atc.classList.remove('asx-hidden');
    }
  }

  function changeQty(card, delta) {
    var a = card.__asx;
    var cur = parseInt(a.step.querySelector('[data-asx-num]').textContent, 10) || 0;
    var next = Math.max(0, cur + delta);
    a.step.classList.add('asx-busy');
    postJSON('/cart/change.js', { id: card.dataset.asxVid, quantity: next })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateBadges(cart.item_count);
        a.step.classList.remove('asx-busy');
        syncAll();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { a.step.classList.remove('asx-busy'); syncAll(); });
  }

  var syncing = false;
  function syncAll() {
    if (syncing) return;
    syncing = true;
    getCart().then(function (cart) {
      syncing = false;
      var map = {};
      (cart.items || []).forEach(function (it) { map[it.variant_id] = it.quantity; });
      updateBadges(cart.item_count);
      document.querySelectorAll('.product-card').forEach(function (card) {
        if (!buildUI(card)) return;
        renderState(card, map[card.dataset.asxVid] || 0);
      });
    }).catch(function () { syncing = false; });
  }

  function init() {
    syncAll();
    // Horizon updates the cart bubble after its own Add to cart -> detect it and morph the card.
    var bubble = document.querySelector('.cart-bubble__text-count') || document.querySelector('[data-testid="cart-bubble"]');
    if (bubble && window.MutationObserver) {
      var _t;
      new MutationObserver(function () { clearTimeout(_t); _t = setTimeout(syncAll, 150); }).observe(bubble, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('cart:refresh', syncAll);
    document.addEventListener('cart:updated', syncAll);
    window.addEventListener('pageshow', syncAll);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
